import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'ly-message',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss',
})
export class MessageComponent {
  @Input()
  title: string | undefined;

  @Input()
  description: string | undefined;

  @Input()
  providerIconName: string | undefined;

  @Input()
  logo: string | undefined;
}
